module.exports = __webpack_public_path__ + "static/media/doghike.32c083fc.jpg";